<template>
  <DialogDef v-if="show" :show="show" :label="label" :width="'711px'" @close="$emit('cancel')">
    <div class="box">
      <p :style="{fontSize: '24px'}" v-html="text"></p>
      <BtnsS @save="$emit('confirm')" :style="{flexDirection: 'row', display: 'flex'}"
      @cancel="$emit('cancel')" :save="'確定'"/>
    </div>
  </DialogDef>
</template>

<script>
import DialogDef from './dialognoPadding2.vue'
import BtnsS from './btn/btns.vue'
export default {
  props: ['text', 'label', 'show'],
  components: { BtnsS, DialogDef }

}
</script>
<style lang="scss" scoped>
.box {
  padding: 40px 80px;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
}
</style>
